import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { NameInput } from 'sections/onsite-campaigns/pages/CampaignEditor/components/NameInput';
import { useSetName } from '../../../../state/SplitTests/actions/useSetName';
import { useSplitTestNameSelector } from '../../../../state/SplitTests/selectors/useSplitTestNameSelector';

export interface SplitTestNameProps {
  id: string;
}

export const SplitTestName = ({ id }: SplitTestNameProps) => {
  const { t } = useTranslation('campaigns');

  const setName = useSetName();
  const name = useSplitTestNameSelector(id);

  const onChange = useCallback(
    name => {
      setName({ id, name });
    },
    [id, setName],
  );

  return (
    <NameInput
      title={t('onsite.editor.workflow.splitTest.workflowName')}
      name={name}
      onChange={onChange}
      aria-label={t('onsite.editor.workflow.splitTest.drawer.drawNameAria')}
      tooltip={{
        content: t('onsite.editor.workflow.splitTest.drawer.nameTooltip'),
      }}
    />
  );
};
